import React, {
  forwardRef,
  ReactNode,
  RefObject,
  useEffect,
  useState,
} from "react";
import { Dropdown } from "@bit-design/react";
import SpecialInput from "components/OrderPlacer/components/SpecialInput";
import PlainSelect from "./select";

declare const Placements: [
  "topLeft",
  "top",
  "topRight",
  "bottomLeft",
  "bottom",
  "bottomRight",
];
declare type Placement = (typeof Placements)[number];

export interface Props {
  items:
    | Array<{
        name: React.ReactNode;
        key: string;
        value?: string | number;
        url?: string;
      }>
    | { [key: string]: React.ReactNode };
  onSelect: (key: any, item: any) => void;
  value?: string;
  height?: number;
  width?: number;
  scrollable?: boolean;
  withoutTheme?: boolean;
  placement?: Placement;
  trigger?: ("click" | "hover" | "contextMenu")[];
  menuWrapperRef?: RefObject<HTMLDivElement>;
  onVisibleChange?: (visible: boolean, dropdownName: string) => void;
  dropdownName?: string;
  customItem?: boolean;
  liStyle?: any;
  isStrategy?: boolean;
  searchKey?: string;
  setSearchKey?: (val) => void;
  overlayClassName?: string;
  showSearch?: boolean;
  children: ReactNode;
  selectWrapperClass?: string;
  dataTestId?: string;
  open?: boolean;
  dataTestIdMap?: {
    // testid  map数据
    [key: string]: React.ReactNode;
  };
  disabled?: boolean;
  dropdownRootClassName?: string;
}

const PlainDropdown = (props: Props) => {
  const {
    items,
    onSelect,
    value,
    placement,
    trigger,
    scrollable,
    menuWrapperRef,
    onVisibleChange,
    dropdownName,
    isStrategy,
    setSearchKey,
    searchKey,
    overlayClassName,
    showSearch = false,
    disabled = false,
    dataTestId = "",
    dropdownRootClassName = "",
    ...otherProps
  } = props;
  const [innerVisible, setInnerVisible] = useState(false);
  useEffect(() => {
    setInnerVisible(props?.open);
  }, [props?.open]);
  function onSelectWrapper(key: string, item: any) {
    onVisibleChange?.(false, dropdownName); // 隐藏回调 告知外界，方便修改css
    setInnerVisible(false);
    onSelect(key, item);
  }
  return (
    <Dropdown
      data-testid={dataTestId}
      trigger={trigger ? trigger : ["click"]}
      overlayClassName={overlayClassName}
      overlay={
        isStrategy ? (
          <div
            className="search-container relative"
            style={{ background: "var(--dialog-bg)" }}
          >
            {showSearch ? (
              <div
                style={{ background: "var(--dialog-bg)" }}
                className="bg-dialogBg  left-[0] right-[0] m-auto search-special-input absolute top-[10px] w-[94%] z-[2]"
              >
                <SpecialInput
                  slim
                  value={searchKey}
                  onChange={(str) => setSearchKey(str)}
                  addonBefore={<i className={"iconfont icon-search"} />}
                />
              </div>
            ) : null}
            <PlainSelect
              items={items}
              onSelect={onSelectWrapper}
              value={value}
              scrollable={scrollable}
              isStrategy={isStrategy}
              showSearch={showSearch}
              {...otherProps}
            />{" "}
          </div>
        ) : (
          <PlainSelect
            items={items}
            onSelect={onSelectWrapper}
            value={value}
            scrollable={scrollable}
            {...otherProps}
          />
        )
      }
      placement={placement || "bottom"}
      open={innerVisible}
      onOpenChange={(visible) => {
        onVisibleChange?.(visible, dropdownName);
        setInnerVisible(visible);
      }}
      getPopupContainer={() => menuWrapperRef?.current ?? document.body}
      disabled={disabled}
      rootClassName={dropdownRootClassName}
    >
      {props.children}
    </Dropdown>
  );
};
export default forwardRef(PlainDropdown);
